import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ConfigService } from 'src/app/provider/config.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-menu-detail',
  templateUrl: './menu-detail.page.html',
  styleUrls: ['./menu-detail.page.scss'],
  standalone: false,
})
export class MenuDetailPage implements OnInit {
  @Input() menu: any;
  show_actual_recipes: number = 0;
  public settings: any;
  private appSettingsSubscription: Subscription;
  storeData: any = {};
  customer: any;
  dummyImg = '../../assets/dummy.png';
  constructor(private modalCtrl: ModalController, private configService: ConfigService, private translate: TranslateService, private authService: AuthService) {}
  ngOnDestroy() {
    if (this.appSettingsSubscription) {
      this.appSettingsSubscription.unsubscribe();
    }
  }
  async ngOnInit() {
    this.customer = await this.authService.getAuthUser();
    this.storeData = await this.configService.configurationsSync();
    this.show_actual_recipes = this.storeData.show_actual_recipes;
    console.log(this.show_actual_recipes,"recipie")
    console.log(this.menu)
    this.appSettingsSubscription = this.configService.appSettings$.subscribe((currentSettings) => {
      this.settings = currentSettings;
      this.translate.setDefaultLang(this.settings.appLanguage);
      this.translate.use(this.settings.appLanguage);
    });
  }
  closeModal = () => {
    this.modalCtrl.dismiss(null, 'cancel');
  };
}
